import { InjectProperty } from '@jack-henry/frontend-utils/di';
import { ACCEPTED_ATTACHMENT_EXTENSIONS } from '@treasury/domain/channel/types/arp/constants';
import { NotificationService, TmBaseComponent } from '@treasury/presentation';
import '@treasury/presentation/components/forms/tm-form-row';
import { TmTextAreaValueChanged } from '@treasury/presentation/components/tm-text-area';
import { html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import '../components/file-uploader.component';
// eslint-disable-next-line no-duplicate-imports
import {
    FileUploadEvent,
    InvalidFileExtensionEvent,
    InvalidFileSizeEvent,
} from '../components/file-uploader.component';

export const tagName = 'check-exception-comment-editor';
@customElement(tagName)
export class CheckExceptionCommentEditor extends TmBaseComponent {
    @property()
    public commentText = '';

    @property()
    public fileName?: string;

    @state()
    public attachment?: File;

    @InjectProperty()
    declare private notificationService: NotificationService;

    public render() {
        return html`
            <div class="flex-col w-full items-center">
                ${this.renderTextarea()}
                <div>${this.renderAttachment()}</div>
            </div>
        `;
    }

    private addAttachment() {
        this.dispatchEvent(
            new CustomEvent('attachment-changed', {
                detail: this.attachment,
            })
        );
    }

    private textChangeEventHandler(e: TmTextAreaValueChanged) {
        this.dispatchEvent(
            new CustomEvent('value-changed', {
                detail: e.detail.value,
            })
        );
    }

    private renderTextarea() {
        return html`
            <tm-form-row label="Comment">
                <div class="relative flex flex-col justify-start w-full">
                    <tm-text-area
                        class="w-full"
                        @value-changed=${this.textChangeEventHandler}
                        .maxLength=${50}
                        .initial=${this.commentText}
                    ></tm-text-area>
                    <div class="pr-4 pb-1 text-right w-11/12">
                        <span class="text-secondary text-xs"
                            >${this.commentText?.length ?? 0}/50</span
                        >
                    </div>
                </div>
            </div>
        `;
    }

    private renderAttachment() {
        return html`
            <file-uploader
                .fileName=${this.fileName}
                showPreview
                .acceptedFileExtensions=${ACCEPTED_ATTACHMENT_EXTENSIONS}
                @filesUploaded=${(e: FileUploadEvent) => {
                    [this.attachment] = e.detail.files;
                    this.addAttachment();
                }}
                @invalidFileSize=${(e: InvalidFileSizeEvent) => {
                    this.notificationService.renderError(
                        html`<p>
                                The selected attachment <i> ${e.detail} </i> has an invalid file
                                size.
                            </p>
                            <p>Maximum file upload size is 4MB.</p>`
                    );
                }}
                @invalidFileExtension=${(e: InvalidFileExtensionEvent) => {
                    this.notificationService.renderError(
                        html`<p>Invalid file extension.</p>
                            <p>Files of the type "${e.detail}" cannot be uploaded.</p>`
                    );
                }}
            ></file-uploader>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: CheckExceptionCommentEditor;
    }
}
